import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconGolfCourse = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconGolfCourse",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M780-120q-25 0-42-17t-18-43 18-42 42-18 43 18 17 42-17 43-43 17M400-80q-100 0-170-23t-70-57q0-23 33-41t87-29v30q0 17 12 29t28 11 29-11 11-29v-616q0-23 19-34t39-2l190 93q23 11 23 36t-22 36l-169 87v362q86 5 143 27t57 51q0 33-70 57T400-80"
  })
}));
IconGolfCourse.displayName = 'IconGolfCourse';